import Sites from './sites';

export default Sites;